import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MTextEllipsisPipe } from './text-ellipsis.pipe';
const pipes = [MTextEllipsisPipe];

@NgModule({
  imports: [CommonModule],
  exports: [pipes],
  declarations: [pipes]
})
export class MPipesModule {}
